module.exports = __webpack_public_path__ + "img/people.c54169cb.png";